import React from 'react';
import { Award, CheckCircle, Users, DollarSign } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Award,
  CheckCircle,
  Users,
  DollarSign
};

export const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* About Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-24">
          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-amber-100 rounded-2xl transform rotate-3"></div>
            <img
              src="https://images.pexels.com/photos/6106506/pexels-photo-6106506.jpeg"
              alt="Auto repair workshop"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover"
            />
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-2xl p-6 max-w-[200px]">
              <div className="text-4xl font-bold text-blue-600 mb-1">4.8★</div>
              <div className="text-sm text-gray-600">Community Trusted Rating</div>
            </div>
          </div>

          {/* Text Content */}
          <div>
            <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Sparky's Auto Electric
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Your Honest, Local Auto Electric Expert
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Run by Skip, Sparky's Auto Electric has built a reputation in Beaverton as the go-to shop for honest, reliable automotive care. Whether you have a mysterious electrical gremlin or just need standard maintenance, we believe in fixing only what needs to be fixed.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              No pressure, no gimmicks—just straightforward expertise. We take pride in being the shop that other mechanics recommend when they encounter complex electrical issues they can't solve.
            </p>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 gap-4">
              <div className="border-l-4 border-blue-600 pl-4">
                <div className="text-2xl font-bold text-gray-900">Same-Day Service</div>
                <div className="text-gray-600">For most repairs</div>
              </div>
              <div className="border-l-4 border-amber-500 pl-4">
                <div className="text-2xl font-bold text-gray-900">Fair Pricing</div>
                <div className="text-gray-600">No hidden fees</div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Sparky's?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another auto shop. We're your neighbors, and we treat your car like it's our own.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUs.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 duration-300 border border-gray-100"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
